import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48a6e990"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, " "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อหนังสือคำสั่ง"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["data-bs-content"]
const _hoisted_7 = ["href", "law"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-alt me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.laws, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "row-hover",
                  onClick: ($event: any) => (_ctx.selectedClick(item.id))
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass([{far: !item.pined, fas: item.pined, 'text-warning': item.pined }, "fa-star me-2"]),
                      style: {"cursor":"pointer"},
                      onClick: _withModifiers(($event: any) => (_ctx.toggleClick(item.id)), ["stop","prevent"])
                    }, null, 10, _hoisted_5)
                  ]),
                  _createElementVNode("td", {
                    class: "column-name text-truncate",
                    "data-bs-toggle": "popover-item",
                    "data-bs-content": item.title
                  }, [
                    _createElementVNode("a", {
                      href: item.file,
                      law: item.title,
                      target: "_blank",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _hoisted_8,
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ], 8, _hoisted_7)
                  ], 8, _hoisted_6),
                  _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(item.createdAt)), 1)
                ], 8, _hoisted_4))
              }), 128))
            ])
          ], 512)
        ]))
  ]))
}